import {
  Modal as ChakraModal,
  type AlertDialogProps as ChakraAlertDialogProps,
} from '@chakra-ui/react';

export type AlertDialogProps = ChakraAlertDialogProps;

/**
 * Core component for rendering an alert dialog.
 *
 * Based on @see https://github.com/chakra-ui/chakra-ui/blob/main/packages/components/modal/src/alert-dialog.tsx
 * but with a variant applied to the Modal in order to provide custom styling
 * which differs from our custom Modal styling.
 */
export const AlertDialog = ({
  leastDestructiveRef,
  ...restProps
}: AlertDialogProps) => {
  return (
    <ChakraModal
      {...restProps}
      initialFocusRef={leastDestructiveRef}
      variant="alertDialog"
    />
  );
};
